import React from 'react';
import { IOldIconProps } from './type';

const Magnifier: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 20}
      height={height || 20}
      viewBox="0 0 18.414 18.414"
      {...props}
    >
      <g id="zoom-2" transform="translate(1 1)">
        <path
          id="Path"
          d="M4.444,4.444,0,0"
          transform="translate(11.556 11.556)"
          fill={'none'}
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2"
          style={{ stroke: color }}
        />
        <circle
          id="Oval"
          cx="6.667"
          cy="6.667"
          r="6.667"
          transform="translate(0 0)"
          fill={'none'}
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2"
          style={{ stroke: color }}
        />
      </g>
    </svg>
  );
};

export default Magnifier;
